import SettingsContent from '../Wrapper';
import AgentBotManagementHome from './Index';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bot-management'),
      component: SettingsContent,
      props: {
        headerTitle: 'AGENT_BOT_MANAGEMENT.HEADER',
        icon: 'robot',
        showBackButton: true,
        backUrl: { name: 'settings_applications' },
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'agent_bot_management_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'agent_bot_management_list',
          roles: ['administrator'],
          component: AgentBotManagementHome,
        },
      ],
    },
  ],
};
